module.exports = __webpack_public_path__ + "img/kh23.2b14693d.png";